import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { useStore } from "../../../helpers";
import { useParams } from "react-router";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export const DownloadSurveyData = observer(() => {
  const { surveyResponseStore } = useStore();
  const { projectid } = useParams();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const activeSurveyId = surveyResponseStore.activeSurveyId;

  const name_with_timestamp = `${surveyResponseStore.activeSurveyId} MobilisHer - ${dayjs().format("YYYY-MM-DD HH:mm:ss")}`;

  const getSurveyData = async () => {
    setLoading(true);
    try {
      const payload = {
        projectid: parseInt(projectid),
        surveyid: activeSurveyId,
      };
      const res = await surveyResponseStore.download_survey_data(payload);
      if (res.status === 200) {
        setData(res.data);
        setReady(true);
      }
    } catch (e) {
      setReady(false);
      alert("Download survey not found.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-row gap-x-4 items-center">
      <Button
        variant="contained"
        color="primary"
        onClick={getSurveyData}
        disabled={loading}
        startIcon={loading && <CircularProgress size={20} color="inherit" />}
      >
        {loading ? "Loading..." : "Download Survey Data"}
      </Button>

      {ready && (
        <CSVLink
          data={data}
          filename={name_with_timestamp}
          onClick={() => setReady(false)}
          className="text-blue-600 underline"
        >
          Click here to download CSV
        </CSVLink>
      )}
    </div>
  );
});
